define('viewmodels/modals/dialogs/CouponDialog',[
    'knockout',
    'common/clientSniffer',
    'plugins/dialog'
], function (ko, client, dialog) {

    function CouponDialog (couponPage, ItunesTermsDialog, couponItem) {
        var isIos = client.device.model === 'iPhone';

        this.dialog = dialog;
        this.couponCode = couponItem.templateParameterValues.property('couponCode');

        this.fields = {
            title: couponPage('title'),
            mainText: couponPage('main_text'),
            decoratedText: couponPage('decorated_text'),
            howTo: couponPage('how_to'),
            termsLabel: couponPage('terms_label'),
            launchUrl: couponPage('launch_url'),
            howToUrl: couponPage('how_to_url'),
            launchLabel: ko.pureComputed(function () {
                if (isIos) {
                    return couponPage('launch_itunes')();
                } else {
                    return couponPage('launch_apple_music')();
                }
            })
        };

        this.openTac = function () {
            dialog.showDialog(new ItunesTermsDialog());
        };
    }

    CouponDialog.prototype.close = function () {
        this.dialog.close(this);
    };

    return CouponDialog;
});

